import { useTranslation } from '@eti/providers';
import {
  NO_CABIN_BAGGAGE,
  NO_CABIN_BAGGAGE_AVAILABLE,
  INCLUDED_CABIN_BAGGAGE,
} from '../../../../../../constants/includedBaggageConstants';
import Feature from '../Feature';
import { getIncludedBaggageText } from '../../utils';
import type { BaggageFeatureProps } from '../model';

const CabinBaggageFeature = ({
  shouldShowNotIncludedProducts,
  brandedFareData,
}: BaggageFeatureProps) => {
  const { t } = useTranslation();
  const cabinBaggageTripSummary =
    brandedFareData?.cabinBaggageTripSummary?.cabinBaggageTravelerDetails?.[0];
  const cabinBaggageStatus = cabinBaggageTripSummary?.cabinBaggageStatus;
  const cabinBaggageDetails = cabinBaggageTripSummary?.cabinBaggageDetails;

  if (cabinBaggageDetails && cabinBaggageStatus === INCLUDED_CABIN_BAGGAGE) {
    const cabinBaggageName = getIncludedBaggageText(
      cabinBaggageDetails,
      'IbeClient.CabinBaggageIncluded.Label',
      t,
    );

    return (
      <Feature
        isIncluded
        key={`${brandedFareData.id}${cabinBaggageName}`}
        label={cabinBaggageName}
      />
    );
  }

  if (
    shouldShowNotIncludedProducts &&
    cabinBaggageStatus &&
    (cabinBaggageStatus === NO_CABIN_BAGGAGE || cabinBaggageStatus === NO_CABIN_BAGGAGE_AVAILABLE)
  ) {
    const cabinBaggageName = t('BrandedFares.CabinBaggageNotIncluded.Text');

    return <Feature key={`${brandedFareData.id}${cabinBaggageName}`} label={cabinBaggageName} />;
  }

  return null;
};

export default CabinBaggageFeature;
